module.exports = __webpack_public_path__ + "assets/img/font2.71b672e8.png";